var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',{staticClass:"title is-1"},[_vm._v("\n    David Mouat Thomson\n    "),_c('br'),_c('span',{staticClass:"subtitle is-4"},[_vm._v("Passionate about Software Architecture, AI Driven Development, and Software Engineering")])])])
}]

export { render, staticRenderFns }